import React from "react";
import { useController, useFormContext } from "react-hook-form";
import { spacing } from "../../../../../../../stitches.config";
import { Label } from "../../../../../../Inputs";
import { Text } from "../../../../../../Inputs/react-hook-form";
import { RichText } from "../../../../../../Inputs/RichText";
import { SelectedSubmissionsBuilderField } from "../../reducer";
import {
  SubmissionsBuilderFieldSettings,
  SubmissionsBuilderFormDataStructure,
} from "../../types";
import FieldsList from "../FieldsList";
import { WidgetSettingsContainer } from "./__styles__/WidgetSettings";

const ObjectFieldTemplateSettings = ({
  fieldPath,
  readOnly,
}: SelectedSubmissionsBuilderField & SubmissionsBuilderFieldSettings) => {
  const { register } = useFormContext<SubmissionsBuilderFormDataStructure>();

  const descriptionController =
    useController<SubmissionsBuilderFormDataStructure>({
      name: `${fieldPath}.description` as any,
    });

  return (
    <WidgetSettingsContainer>
      <div>
        <Label text={"Title"} htmlFor={`${fieldPath}.title`} required />
        <Text {...register(`${fieldPath}.title`)} disabled={readOnly} />
        <Label
          text={"Description"}
          htmlFor={`${fieldPath}.description`}
          style={{ marginTop: spacing.m.toString() }}
        />
        <RichText
          name={`${fieldPath}.description`}
          value={descriptionController.field.value ?? ""}
          onChange={descriptionController.field.onChange}
          disabled={readOnly}
        />
      </div>
      {!readOnly && <FieldsList />}
    </WidgetSettingsContainer>
  );
};

ObjectFieldTemplateSettings.displayName = "ObjectFieldTemplateSettings";

export default ObjectFieldTemplateSettings;
